const CostCentersPeopleAssignment = () => {
  return <></>
}

export { CostCentersPeopleAssignment }
